import React from 'react';

// import { FpjsProvider } from '@fingerprintjs/fingerprintjs-pro-react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from '@/layouts/App';

import '@nosferatu500/react-sortable-tree/style.css';

const domNode = document.getElementById('root') as HTMLElement;
const root = createRoot(domNode);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <DndProvider backend={HTML5Backend}>
        {/* <FpjsProvider
          loadOptions={{
            apiKey: process.env.REACT_APP_FINGERPRINTJS_APP_KEY as string,
          }}
        > */}
        <App />
        {/* </FpjsProvider> */}
      </DndProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
